import {TriggerStyle, TriggerStyleInput,} from "./Common/TriggerStyle";
import {BaseWidgetConfiguration, BaseWidgetConfigurationInput} from "./BaseWidget";
import {PunkuConfig} from "../../ChatBotProviders/Punku/composables/types";
export const FLOATING_WIDGET_TYPE = 'floatingWidget';
export const FLOATING_WIDGET_CONFIGURATION_VERSION = '0.2.0';

export type ChatBotProviderConfig = {
    punku?: Pick<PunkuConfig, 'publishableKey'|'flowId'>;
    displayChat?: boolean;
    experiencesForChatbot?: string[];
};

// #region FloatingWidgetType
export interface FloatingWidgetType extends BaseWidgetConfiguration {
    type:  typeof FLOATING_WIDGET_TYPE,
    /**
     *  The experiences for which to sell tickets
     */
    experiencesForTickets: string[],
    experiencesForVouchers: string[],
    /**
     *  The flexOffers, for which to sell
     */
    flexOffers: string[],
    /**
     *  The order of experiences should display on widget
     */
    experiencesSortOrder: string[],
    trigger: TriggerStyle | HTMLElement[],
    id: string,
    openOnLoad: boolean,
    chatBotProvider?: ChatBotProviderConfig,
    webshopVisibility?: boolean,
}
// #endregion FloatingWidgetType

export interface FloatingWidgetConfigurationInput extends BaseWidgetConfigurationInput {
    experiencesForTickets: string[],
    experiencesForVouchers: string[],
    flexOffers?: string[],
    /**
     *  The order of experiences should display on widget
     */
    experiencesSortOrder?: string[],
    trigger?: TriggerStyleInput,
    id: string,
    /** @default false */
    openOnLoad?: boolean,
    type:  typeof FLOATING_WIDGET_TYPE,
    chatBotProvider?: ChatBotProviderConfig,
    webshopVisibility?: boolean,
};


